import React from 'react';
import type { AppTheme } from '@/theme/index';
import { MenuItem, type MenuItemVariation } from '../MenuItem';

interface AccountProps {
  userName: string;
  isOpen: boolean;
  theme: AppTheme;
  onClick?: () => void;
}

export const Account: React.FC<AccountProps> = ({ userName, isOpen, theme, onClick }) => {
  const variation: MenuItemVariation = 'account';

  return (
    <MenuItem
      icon="/icons/user.svg"
      label={userName}
      isOpen={isOpen}
      theme={theme}
      variation={variation}
      onClick={onClick}
    />
  );
};
